export enum NotificationType {
	Success = 'success',
	Error = 'error',
	Warning = 'warning',
	Info = 'info'
}
